import React from "react";
import styled from "styled-components";
import { ViewSelector } from "./ViewSelector";
import { View } from "./constants";
import IntlStore from "stories/IntlStore";

interface StatusbarProps {
  selectedStatus: string;
  onStatusClick: (status: string) => void;
  view: View;
  onChangeView: (view: View) => void;
  isMobile?: boolean;
}

const statuses = [
  {
    value: '',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.AllReleases",
      defaultMessage: "All releases"
    })
  },
  {
    value: 'DRAFT',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.Draft",
      defaultMessage: "Draft"
    })
  },
  {
    value: 'MODERATE',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.Moderation",
      defaultMessage: "Moderation"
    })
  },
  {
    value: 'WAITING',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.AwaitingDelivery",
      defaultMessage: "Awaiting delivery"
    })
  },
  {
    value: 'ERROR',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.Error",
      defaultMessage: "Error"
    })
  },
  {
    value: 'RELEASED',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.Released",
      defaultMessage: "Released"
    })
  },
  {
    value: 'REMOVED',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.Deleted",
      defaultMessage: "Deleted"
    })
  },
  {
    value: 'EDIT',
    label: IntlStore.intl.formatMessage({
      id: "Releases.Statusbar.Editing",
      defaultMessage: "Editing"
    })
  },
];

export const Statusbar: React.FC<StatusbarProps> = props => {
  return (
    <Container>
      <StatusScroller>
        <StatusPanel>
          {statuses.map(status => (
            <Status
              key={status.value || "ALL"}
              $isActive={props.selectedStatus === status.value}
              onClick={() => props.onStatusClick(status.value)}
            >
              {status.label}
            </Status>
          ))}
        </StatusPanel>
      </StatusScroller>
      <Right>
        <ViewSelector view={props.view} onChangeView={props.onChangeView} hideTile={props.isMobile} />
      </Right>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  width: 100%;
  overflow: hidden;
`;

const Right = styled.div`
  flex: 0 0 auto;
`;

const StatusScroller = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const StatusPanel = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: nowrap;
  white-space: nowrap;
`;

const Status = styled.div<{ $isActive: boolean }>`
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 5px;
  background-color: ${props => props.$isActive ? '#E2E5FF' : 'transparent'};
  color: ${props => props.$isActive ? '#000000' : '#7C7C7C'};
  font-weight: ${props => props.$isActive ? 500 : 400};
  font-size: 15px;
  line-height: 20px;
`;
